import { gql } from "apollo-angular";

export const TRY_LOCK_ITEM_MUTATION = gql`mutation configuratorTryLockItem($ItemUid: String!) {
    configuratorTryLockItem(ItemUid: $ItemUid)
  }
  `

  export const UNLOCK_ITEM_MUTATION = gql`mutation configuratorUnlockItem($ItemUid: String!) {
    configuratorUnlockItem(ItemUid: $ItemUid)
  }
  `

// Go Lambda lock/unlock mutations
export const FDD_LOCK_ITEM_MUTATION = gql`
  mutation lockItem($itemType: ItemType!, $itemUid: String!) {
    lockItem(itemType: $itemType, itemUid: $itemUid) {
      acquired
      itemType
      itemUid
      lockedBy
      lockedAt
      reason
    }
  }
`;

export const FDD_UNLOCK_ITEM_MUTATION = gql`
  mutation unlockItem($itemType: ItemType!, $itemUid: String!) {
    unlockItem(itemType: $itemType, itemUid: $itemUid) {
      acquired
      itemType
      itemUid
      lockedBy
      lockedAt
      reason
    }
  }
`;